import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";

export default function AddUpdateCity({
  type,
  getAxiosInstance,
  Toast,
  cityUp,
  getCountries,
  getStates,
  getCities,
}) {
  const [IsShowing, setIsShowing] = useState(false);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [inputCountry, setInputCountry] = useState("");
  const [inputState, setInputState] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [countryOpt, setCountryOpt] = useState("");
  const [allCountry, setAllCountry] = useState([]);

  const [stateOpt, setStateOpt] = useState("");
  const [allState, setAllState] = useState([]);

  useEffect(() => {
    if (cityUp) {
      setCity(cityUp.name);
      setState(cityUp.state);
      setCountry(cityUp.country);
    }
  }, [cityUp]);

  const fetchCountryData = () => getCountries(inputCountry);
  const fetchStateData = () => getStates(inputState, country?._id);

  // get country option
  useEffect(() => {
    const params = {};
    getAxiosInstance()
      .post("/admin/countries", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        console.log(res.data.result);
        setAllCountry(res.data.result);
      })
      .catch((err) => console.log(err));
  }, []);

  // get states option
  useEffect(() => {
    let formdata = new FormData();
    //add three variable to form
    formdata.append("country", country);
    console.log({ inputCountry });
    // const data = JSON.parse(country);
    getAxiosInstance()
      .post(
        "/admin/states",
        { country: countryOpt }
        // {
        //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllState(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [countryOpt]);

  useEffect(() => {
    if (cityUp) {
      setStateOpt(cityUp.state._id);
      setCountryOpt(cityUp.country._id);
    }
  }, []);

  const addCity = () => {
    if (countryOpt === "" || !countryOpt)
      return Toast.fire({ icon: "error", title: "Country selection required" });
    if (stateOpt === "" || !stateOpt)
      return Toast.fire({ icon: "error", title: "State selection required" });
    if (city.trim() === "")
      return Toast.fire({ icon: "error", title: "City name required." });

    setIsLoading(true);
    let link = "/admin/add-city";
    let params = {
      name: city,
      state: stateOpt,
      country: countryOpt,
    };
    if (cityUp) {
      params = {
        cityId: cityUp._id,
        name: city,
        state: stateOpt,
        country: countryOpt,
      };
      link = "/admin/update-city";
    }

    const data = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    getAxiosInstance()
      .post(link, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        // console.log(res.data)
        if (res.data.status === "success") {
          Toast.fire({
            icon: "success",
            title: `City ${type === "add" ? "added" : "updated"} successfully.`,
          });
          handleClose();
          getCities();
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot Process Request" });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 401)
          Toast.fire({ icon: "error", title: "Unauthorized Access" });
        console.log(err);
      });
  };

  function handleClose() {
    setIsShowing(false);
    setCity("");
    setState("");
    setCountry("");
    // window.location.reload()
  }

  return (
    <>
      {type === "add" && (
        <button
          type="button"
          class="btn btn-dark btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-plus"></i> Add City
        </button>
      )}
      {type !== "add" && (
        <button
          type="button"
          class="btn btn-success btn-sm ml-1"
          title="Edit"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-pen"></i>
        </button>
      )}
      {IsShowing && (
        <div
          className={`modal fade show`}
          id="modal-default"
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">City Modal</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClose()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group mt-3">
                      <select onChange={(e) => setCountryOpt(e.target.value)}>
                        {type != "add" ? (
                          <option>{cityUp.country.name}</option>
                        ) : (
                          <option>Select Country---</option>
                        )}
                        {allCountry.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mt-3">
                      <select onChange={(e) => setStateOpt(e.target.value)}>
                        {type != "add" ? (
                          <option>{cityUp.state.name}</option>
                        ) : (
                          <option>Select State---</option>
                        )}
                        {allState.map((opt, i) => (
                          <option key={i} value={opt._id}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control mt-3"
                        id="city"
                        placeholder={"Enter City Name"}
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={(e) => handleClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={(e) => addCity()}
                  disabled={isLoading}
                >
                  {type === "add" ? "Add City" : "Save changes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
